<mat-form-field appearance="outline" style="width: 100%;">
  <mat-label>País</mat-label>
  <input
    type="text"
    matInput
    [formControl]="countryControl"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
    (optionSelected)="onCountrySelected($event)"
  >
    <mat-option
      *ngFor="let country of filteredCountries | async"
      [value]="country"
    >
      {{ country.flag }} {{ country.name }} (+{{ country.ddi }})
    </mat-option>

  </mat-autocomplete>
</mat-form-field>
